import React from 'react';
import { StoryOverlay } from '../StoryOverlay';
import { SectionLink } from '../SectionLink';

/**
 * Story page. The body is the overlay — hero, where we are grounded, the beat
 * rows, where we're going, and the closing contract — so it renders as a
 * single component rather than a stack of independent sections.
 *
 * Replaced the old StorySection timeline + IngredientsBanner pairing; the
 * ingredients photograph now lives inside the "Where we are grounded" row.
 * The club link is kept from the previous page so Story still threads to
 * #club like every other page.
 */
export function StoryPage() {
  return (
    <>
      <StoryOverlay />
      <section className="section fade-in" style={{ paddingTop: '1rem', paddingBottom: '4rem' }}>
        <SectionLink to="/club">Order TrueNooch direct</SectionLink>
      </section>
    </>
  );
}
